import React from 'react';
import FieldLabel from '../atoms/FieldLabel';
import Input from '../atoms/Input';
import Select from '../atoms/Select';
import Textarea from '../atoms/Textarea';

/**
 * Labeled form control molecule.
 */
export default function FormField({
  label,
  hint,
  children,
  className = '',
  htmlFor,
}) {
  return (
    <div className={`ca-form-field ${className}`.trim()}>
      {label != null ? (
        <FieldLabel htmlFor={htmlFor} hint={hint}>
          {label}
        </FieldLabel>
      ) : null}
      {children}
    </div>
  );
}

export function FormInput({ label, hint, ...inputProps }) {
  return (
    <FormField label={label} hint={hint} htmlFor={inputProps.id}>
      <Input {...inputProps} />
    </FormField>
  );
}

export function FormInputWithButton({ label, hint, suffix, ...inputProps }) {
  return (
    <FormField label={label} hint={hint} htmlFor={inputProps.id}>
      <div className="input-with-suffix">
        <Input {...inputProps} />

        {suffix && (
          <div className="input-suffix">
            {suffix}
          </div>
        )}
      </div>
    </FormField>
  );
}

export function FormSelect({ label, hint, ...selectProps }) {
  return (
    <FormField label={label} hint={hint} htmlFor={selectProps.id}>
      <Select {...selectProps} />
    </FormField>
  );
}

export function FormTextarea({ label, hint, maxLength, value = '', ...textareaProps }) {
  const computedHint =
    hint ??
    (maxLength != null ? `${String(value).length}/${maxLength}` : undefined);

  return (
    <FormField label={label} hint={computedHint} htmlFor={textareaProps.id}>
      <Textarea value={value} maxLength={maxLength} {...textareaProps} />
    </FormField>
  );
}
